/**
 * Page Context Store — lets child routes push contextual data (title, links, actions)
 * into the SiteHeader without prop drilling or ReactNode slots.
 */

import { create } from "zustand";

interface PageContext {
	title?: string;
	subtitle?: string;
	subtitleLink?: string;
	shareRunId?: number;
	/** Non-null when the run is already publicly shared. */
	shareToken?: string | null;
	scheduleAction?: { taskId: number; agentInstanceId: number };
}

interface PageContextState extends PageContext {
	scheduleModalRequested: boolean;
	setPageContext: (ctx: PageContext) => void;
	clearPageContext: () => void;
	requestScheduleModal: () => void;
}

export const usePageContextStore = create<PageContextState>((set) => ({
	scheduleModalRequested: false,
	setPageContext: (ctx) => set({ ...ctx, scheduleModalRequested: false }),
	clearPageContext: () =>
		set({
			title: undefined,
			subtitle: undefined,
			subtitleLink: undefined,
			shareRunId: undefined,
			shareToken: undefined,
			scheduleAction: undefined,
			scheduleModalRequested: false,
		}),
	requestScheduleModal: () => set({ scheduleModalRequested: true }),
}));
